// extracted by mini-css-extract-plugin
export default {"area":"About_area__LlVEG","header":"About_header__eqrLL","content":"About_content__clLqi","card":"About_card__4Mdz6","placeholder":"About_placeholder__RKsYv"};